import {Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import {NgbPagination} from "@ng-bootstrap/ng-bootstrap";
import {SharedModule} from "app/modules/shared/shared.module";

@Component({
  selector: 'app-pagination',
  imports: [
    NgbPagination,
    SharedModule
  ],
  templateUrl: './pagination.component.html',
  standalone: true,
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent<T> implements OnInit, OnChanges {
  @Input() filteredList: T[] = [];
  @Input() pageOptions: number[] = [10, 20, 50];
  @Input() initialPageSize = 10;

  @Output() pageChange = new EventEmitter<T[]>();
  pageSize = this.initialPageSize;
  page = 1;
  totalPages = 1;
  pagedList: T[] = [];
  pageItemRange = '';

  ngOnInit() {
    this.pageSize = this.initialPageSize;
    this.setPage(1);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes["filteredList"]!.isFirstChange()) {
      // todo: revisit the following so that we don't need to use Promise.resolve() to defer the execution until the next cycle.
      Promise.resolve().then(() => { // defer until after the current cycle
        this.setPage(1);
      });
    }
  }

  /** Parent can call this via @ViewChild */
  setPage(page?: number) {
    if (page) {
      this.page = Math.max(1, page);
    }
    const totalCount = this.filteredList.length;
    if (this.pageSize < totalCount) {
      this.totalPages = Math.ceil(totalCount / this.pageSize);
      this.page = Math.min(this.page, this.totalPages);
      const startIndex = (this.page - 1) * this.pageSize;
      const endIndex = Math.min(startIndex + this.pageSize, totalCount);
      this.pagedList = this.filteredList.slice(startIndex, endIndex);
      this.pageItemRange = `${startIndex + 1} to ${endIndex}`;
    } else {
      this.totalPages = 1;
      this.pagedList = this.filteredList;
      this.pageItemRange = `${totalCount}`;
    }
    this.pageChange.emit(this.pagedList);
  }
}
